function throwError() {
    //eslint-disable-next-line
    console.warn('can not call rp sdk on server side')
}

export default {
    get: throwError,
}
